import { useState, useMemo } from "react";
import { useGetAppointmentsQuery } from "@/queries/useGetAppointmentsQuery";

export const useCalendar = () => {
  const [value, onChange] = useState(new Date());

  const { data: appointmentsData } = useGetAppointmentsQuery({ activeOnly: false });

  const dateArr = useMemo(() => {
    if (!appointmentsData) return [];

    return appointmentsData
      .filter((date) => date.status !== "canceled")
      .map((date) => date.start_date.substr(0, 10));
  }, [appointmentsData]);

  return {
    value,
    onChange,
    dateArr,
  };
};
